import { render, staticRenderFns } from "./ClientProjects.vue?vue&type=template&id=ed2bb6a4&"
import script from "./ClientProjects.vue?vue&type=script&lang=js&"
export * from "./ClientProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports